import { getBaseId } from './getBaseId';

/** Shape: 1630000000000-1f8b2bcfff00 */
export const getSessionIdCookieValue = getBaseId;
